export default __webpack_public_path__ + "c536a8fdc24d61bf4084baefba4c9c5c.png";